"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _base = babelHelpers.interopRequireDefault(require("./base"));

var CollectionCard = _base.default.makeDefaultCardType('collection', 'Collection');

var _default = CollectionCard;
exports.default = _default;